/** Tokens centralizados para campos de formulário V2. */
export const FORM_FIELD_HEIGHT = 40;
export const FORM_FIELD_INPUT_PADDING = '8px 12px';
export const FORM_FIELD_FONT_SIZE = 14;
export const FORM_FIELD_FONT_WEIGHT = 400;
